export const BOM_INPUT_REQUIRED_MESSAGE = 'A BOM needs at least one Input.';
//# sourceMappingURL=bom-input-required-message.js.map